export default __webpack_public_path__ + "static/media/comment.951a498e.png";